import axios from "axios"
import { useState } from "react"
import { HiOutlinePhotograph } from "react-icons/hi"

interface Props {
  title: string
  url: string
  textButton: string
  nameFile: string
}
const Socialshare = ({ title, url, textButton, nameFile}:Props) => {
  const [isLoadingImg, setIsLoadingImg] = useState<boolean>(false)
  const Download = () => {
    setIsLoadingImg(true)
    axios({
      url,
      method: 'GET',
      responseType: 'blob'
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url;
        link.setAttribute('download', `${nameFile}.png`)
        document.body.appendChild(link)
        link.click()
        setIsLoadingImg(false)
      })
      .catch(() => {
        setIsLoadingImg(false)
      })
  }
  return (
    <div className="c-code-qr__container">
      <div className="c-code-qr__header">
        <span className="c-code-qr__title">{title}</span>
      </div>
      <div className="c-code-qr__content-social" >
        <img src={url} className={`c-code-qr__img-social`} alt="img-social-share" />
      </div>
      <button className={`c-code-qr__button-download c-code-qr__button-download--social ${isLoadingImg && `c-code-qr__button-download--disabled`}`} onClick={Download}>
        {
          isLoadingImg ?
            <>
              Download...<div className="spiner"></div>
            </>
            :
            <>
              {textButton} <HiOutlinePhotograph />
            </>
        }
      </button>
    </div>
  )
}

export default Socialshare